<template>
  <el-table-column
    prop="representativeUser.last_name"
    label="Képviselő"
    show-overflow-tooltip
    width="200px"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.representative_users">
        <p
          v-for="user in scope.row.representative_users"
          :key="user.id"
          style="margin: 0; line-height: 1.5;"
        >
          {{ user.last_name }} {{ user.first_name }}
        </p>
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'representativeUser.last_name',
  };
</script>
